<div class="relative">
  <button
    type="button"
    class="btn-situacao"
    [class.btn-situacao--ativa]="!!valorSelecionado"
    (click)="toggle()">
    <lucide-icon name="filter" class="w-4 h-4 shrink-0"></lucide-icon>
    <span class="btn-situacao__label">{{ labelSelecionada }}</span>
    <lucide-icon name="chevron-down" class="w-3.5 h-3.5 shrink-0 opacity-60"></lucide-icon>
  </button>

  <ul *ngIf="isOpen" class="situacao-dropdown"
    [style.max-height]="dropdownMaxHeight"
    [style.overflow-y]="dropdownMaxHeight ? 'auto' : null">

    <!-- Cabeçalho: label + Limpar -->
    <li class="situacao-dropdown__header">
      <span>{{ placeholder }}</span>
      <button type="button" class="situacao-dropdown__limpar" (click)="limpar($event)">Limpar</button>
    </li>

    <!-- Opções com radio -->
    <li *ngFor="let opcao of opcoes; trackBy: trackByOpcao">
      <button
        type="button"
        class="situacao-opcao"
        [class.situacao-opcao--ativa]="valorSelecionado === opcao.valor"
        (click)="selecionar(opcao.valor)">
        <span
          class="radio-circle"
          [class.radio-circle--ativo]="valorSelecionado === opcao.valor">
          <span *ngIf="valorSelecionado === opcao.valor" class="radio-circle__dot"></span>
        </span>
        <span>{{ opcao.label }}</span>
      </button>
    </li>
  </ul>
</div>
